import bidello from '../../bidello'
// import Stats from 'stats.js'

// const stats = new Stats()
// stats.showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom
// document.body.appendChild(stats.dom)

class Raf {
  constructor() {
    this.time = window.performance.now()

    this.start = this.start.bind(this)
    this.pause = this.pause.bind(this)
    this.onTick = this.onTick.bind(this)

    this.skipFrame = false

    this.start()
  }

  start() {
    this.startTime = window.performance.now()
    this.oldTime = this.startTime
    this.isPaused = false

    this.onTick(this.startTime)
  }

  pause() {
    this.isPaused = true
  }

  onTick(now) {
    // stats.begin()
    this.time = now

    if (this.skipFrame) {
      if (!this.isPaused) {
        this.delta = (now - this.oldTime) / 1000
        this.oldTime = now

        bidello.trigger({ name: 'raf' }, {
          delta: this.delta,
          now,
        })
      }
    }


    // stats.end()
    this.skipFrame = !this.skipFrame
    window.requestAnimationFrame(this.onTick)
  }
}

export const raf = new Raf()
